const SparklesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 14" style={{ display: 'block' }}>
    <defs>
      <linearGradient id="sparklesShine" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#00BFFF" />
        <stop offset="50%" stopColor="#0071c2" />
        <stop offset="100%" stopColor="#6C5CE7" />
      </linearGradient>
    </defs>
    <path fill="url(#sparklesShine)" d="M7 0c0 0 2 3.5 2.5 5 .5 1.5 5 2.5 5 2.5s-4.5 1-5 2.5C9 11.5 7 14 7 14s-2-2.5-2.5-4C4 8.5 0 7.5 0 7.5s4.5-1 5-2.5C5.5 3.5 7 0 7 0z" />
    <path fill="url(#sparklesShine)" d="M16.5 1c0 0 .6 1.3.8 1.8.2.5 2 .9 2 .9s-1.8.4-2 .9c-.2.5-.8 1.8-.8 1.8s-.6-1.3-.8-1.8c-.2-.5-2-.9-2-.9s1.8-.4 2-.9c.2-.5.8-1.8.8-1.8z" />
  </svg>
)

export default SparklesIcon
